<template>
  <div class="flex flex-column gap-1">
    <label>Restricted Validation</label>
    <div class="flex align-items-center gap-2">
      <InputSwitch
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
      />
      <span class="text-500 text-sm">
        When on, snippets flagged for offensive content are excluded from this
        seller's playlist entirely
      </span>
    </div>
  </div>
</template>

<script setup>
import InputSwitch from "primevue/inputswitch";

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});
defineEmits(["update:modelValue"]);
</script>
